import React from "react";
import { Box, Center } from '@chakra-ui/react'

type Props = { children: React.ReactNode }

const AuthLayout: React.FC<Props> = ({ children }) => {
  return (
    <React.Fragment>
      <Box 
        h="100vh" w="100%" 
        bgColor='#E3FCC7' 
        bgImage="url('/assets/imgs/mountain_hills.jpg')" 
        bgPosition="center" bgRepeat="no-repeat" 
        bgSize="cover"
      >
        <Center 
          px={[4]} w="100%" h="100vh" 
          maxW={600} mx="auto"
        >
          {children}
        </Center>
      </Box>
    </React.Fragment>
  )
}

export default AuthLayout